<ng-container *transloco="let t">
  @if (
    {
      menu: menu$ | async
    };
    as ctx
  ) {
    @if (ctx.menu && ctx.menu.children.length) {
      <cft-nav-list-item-expandable [title]="ctx.menu.title" [isExpanded]="false" [testIdList]="'craftsmen-menu-list'">
        <ul cft-nav-list class="pt-1">
          @for (menuChild of ctx.menu.children; track menuChild; let i = $index) {
            @if (menuChild.children?.length) {
              <li
                cft-nav-list-item-expandable
                [indentation]="1"
                [isExpanded]="false"
                [title]="menuChild.title"
                [testIdList]="'menu-item-' + i"
              >
                <ul>
                  <li>
                    @if (menuChild.link.type === 'Url') {
                      <a [href]="externalUrl(menuChild.link)" bgoOpenNewTab [indentation]="2" cft-nav-list-item>
                        {{ t('navbar.overview') }}
                      </a>
                    }
                    @if (menuChild.link.type === 'Path') {
                      <a
                        cft-nav-list-item
                        [indentation]="2"
                        [routerLink]="path(menuChild.link)"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}"
                      >
                        {{ t('navbar.overview') }}
                      </a>
                    }
                  </li>
                  @for (subItem of menuChild.children; track subItem) {
                    <li>
                      @if (subItem.link.type === 'Url') {
                        <a [href]="externalUrl(subItem.link)" bgoOpenNewTab [indentation]="2" cft-nav-list-item>
                          {{ subItem.title }}
                        </a>
                      }
                      @if (subItem.link.type === 'Path') {
                        <a
                          cft-nav-list-item
                          [indentation]="2"
                          [routerLink]="path(subItem.link)"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{exact: true}"
                        >
                          {{ subItem.title }}
                        </a>
                      }
                    </li>
                  }
                </ul>
              </li>
            } @else {
              <li [attr.data-testid]="'menu-item-' + i">
                @if (menuChild.link.type === 'Url') {
                  <a [href]="externalUrl(menuChild.link)" bgoOpenNewTab [indentation]="1" cft-nav-list-item>
                    {{ menuChild.title }}
                  </a>
                }
                @if (menuChild.link.type === 'Path') {
                  <a
                    cft-nav-list-item
                    [indentation]="1"
                    [routerLink]="path(menuChild.link)"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"
                  >
                    {{ menuChild.title }}
                  </a>
                }
              </li>
            }
          }
        </ul>
      </cft-nav-list-item-expandable>
    }
  }
</ng-container>
